import h from "./html";
import Login from "./Login";
import PasswordReset from "./PasswordReset";
import Settings from "./Settings";
import Db from "./db";
import IcsView from "./IcsView";
import SharedDbConnection from "./SharedDbConnection";
import Sidebar from "./Sidebar";
import CreateEvent from "./CreateEvent";

if (process.env.NODE_ENV !== "production") {
  new EventSource("/esbuild").addEventListener("change", () => {
    // hack -- delay slightly for tailwind.
    setTimeout(() => {
      location.reload();
    }, 400);
  });
}

function Routes({ db }: { db: Db }) {
  const me = db.query(
    /* sql */ "SELECT user_id, name, email FROM me LEFT JOIN user USING (user_id)",
    ["userId", "name", "email"],
    [],
  );
  const status = h.derive(() => {
    if (me.val === "loading") return "loading";
    else if (me.val.length === 0) return "loggedOut";
    else if (me.val.length === 1) return "loggedIn";
  });

  const pathname = h.pathnameState();

  return () =>
    status.val === "loading" ? (
      ""
    ) : status.val === "loggedOut" ? (
      <div>
        {() =>
          pathname.val.startsWith("/reset") ? (
            <PasswordReset db={db} />
          ) : (
            <Login db={db} />
          )
        }
      </div>
    ) : (
      <div className="flex min-h-screen flex-col-reverse sm:flex-row h-screen">
        <Sidebar />
        {() => (pathname.val === "/" ? <IcsView db={db} /> : "")}
        {() => (pathname.val === "/event/new" ? <CreateEvent db={db} /> : "")}
        {() => (pathname.val === "/settings" ? <Settings db={db} /> : "")}
      </div>
    );
}

h.add(document.body, <Routes db={new Db(new SharedDbConnection())} />);
